<script setup lang="ts">
import { computed } from "vue";
import { Music2 } from "@lucide/vue";

const props = defineProps<{ title: string; index?: number }>();
const palettes = [
  "linear-gradient(145deg, #ddff5b 0%, #8bd9a4 52%, #173a2c 100%)",
  "linear-gradient(145deg, #ffb19f 0%, #ff6949 50%, #572921 100%)",
  "linear-gradient(145deg, #d9c8ff 0%, #846fd1 48%, #22233e 100%)",
  "linear-gradient(145deg, #ffe49b 0%, #e8a43a 48%, #263c35 100%)",
];
const artwork = computed(
  () => palettes[(props.index ?? props.title.length) % palettes.length],
);
</script>

<template>
  <div class="track-artwork" :style="{ background: artwork }">
    <span class="artwork-noise" aria-hidden="true" />
    <span class="artwork-ring ring-a" />
    <span class="artwork-ring ring-b" />
    <span class="artwork-wave" aria-hidden="true"><i /><i /><i /><i /><i /><i /><i /></span>
    <Music2 :size="24" :stroke-width="1.5" />
    <small>{{ title.slice(0, 10) }}</small>
  </div>
</template>
